import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuthContext();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Only redirect if we're not loading and user is definitely not authenticated
    if (!loading && !user) {
      // Redirect to signup with the current path as redirect parameter
      // Most users accessing templates are new users, so signup is the better default
      const redirectPath = location.pathname + location.search;
      navigate(`/register?redirect=${encodeURIComponent(redirectPath)}`, { 
        state: { 
          fromTemplate: true,
          message: 'Create a free account to access this feature'
        } 
      });
    }
  }, [user, loading, location, navigate]);

  // Show loading state while authentication is being checked
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // If user exists, render the protected content
  if (user) {
    return children;
  }

  // While redirecting, show a loading state
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to sign up...</p>
      </div>
    </div>
  );
} 